import { TemplateType, type Template, type ConfluenceTemplate, type LinkTemplate } from './types';

export const isConfluenceTemplate = (template?: Template): template is ConfluenceTemplate =>
	template?.type === TemplateType.Confluence;

export const isMoreTemplates = (template?: Template): template is LinkTemplate =>
	template?.type === TemplateType.Link;
